module.exports = __webpack_public_path__ + "static/media/upgrade.5245af4b.gif";